export default class Queue {
    
    constructor() {
        this.length = 0;
    }

    enqueue(value) {
        let newLast = { val: value, next: null, prev: this.last};
        
        if (this.length === 0) {
            this.first = newLast;
        }
        else {
            this.last.next = newLast;
        }
        this.last = newLast;
        
        this.length++;
    }

    dequeue() {
        if (this.length === 0) {
            throw new Error("Queue is empty");
        }

        let v = this.first.val;        
        this.length--;

        if (this.length === 0) {
            this.first = undefined;
            this.last = undefined;
        }
        else {
            this.first = this.first.next;
            this.first.prev = null;
        }
        return v;        
    }

    enqueueRange(values) {
        values.forEach(value => {
            this.enqueue(value);
        });
    }

    * getIterator() {
        let current = this.first;
        while (current) {
            yield current;
            current = current.next;
        }
    }

    toArray() {
        let iterator = this.getIterator();
        let a = [];

        for(let cur of iterator) {
            a.push(cur.val);
        }

        return a;
    }

    static fromArray(array) {
        var queue = new Queue();
        queue.enqueueRange(array);
        return queue;
    }

    clone() {
        return Queue.fromArray(this.toArray());
    }

    toString() {
        return '[' + this.toArray().join(", ") + ']';
    }
}